import { render } from "./footBar.vue?vue&type=template&id=2bd728e2&scoped=true"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"

import "./footBar.vue?vue&type=style&index=0&id=2bd728e2&scoped=true&lang=scss"

import exportComponent from "D:\\SelfCode\\ktpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd728e2"]])

export default __exports__